import React from 'react';
import { LabelInput, LabelSelect, MoneyInput } from '../../../components/Input/Input';
import { ACCOUNT_TYPE_OPTIONS, STATUS_OPTIONS } from '../../../core/constants/financial';
import FinancialFormModal from './FinancialFormModal';

const BankFormModal = ({ form, setForm, editingId, onSave, onClose, onDelete, saving }) => {
  const onChange = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  return (
    <FinancialFormModal
      title={editingId ? 'Editar Banco' : 'Novo Banco'}
      onClose={onClose}
      onSave={onSave}
      onDelete={onDelete}
      saving={saving}
    >
      <div className="fd-form-row fd-form-row--code-name">
        <LabelInput
          label="Código Banco"
          value={form.code}
          placeholder="Ex: 077"
          max={10}
          onChange={(value) => onChange('code', value)}
        />
        <LabelInput
          label="Nome do Banco"
          value={form.name}
          placeholder="Ex: Banco Inter"
          max={100}
          onChange={(value) => onChange('name', value)}
        />
      </div>

      <div className="fd-form-row">
        <LabelInput
          label="Agência"
          value={form.agency}
          placeholder="0001-5"
          max={20}
          onChange={(value) => onChange('agency', value)}
        />
        <LabelInput
          label="Conta Corrente"
          value={form.account}
          placeholder="12345-6"
          max={30}
          onChange={(value) => onChange('account', value)}
        />
      </div>

      <div className="fd-form-row">
        <LabelSelect menuPortalTarget={document.body}
          label="Tipo de Conta"
          options={ACCOUNT_TYPE_OPTIONS}
          value={ACCOUNT_TYPE_OPTIONS.find((o) => o.value === form.account_type)}
          placeholder="Selecione"
          onChange={(opt) => onChange('account_type', opt?.value || 'corrente')}
        />
        <LabelInput
          label="Titular"
          value={form.holder}
          placeholder="Razão Social ou CPF/CNPJ"
          max={150}
          onChange={(value) => onChange('holder', value)}
        />
      </div>

      <div className="fd-form-row">
        <MoneyInput
          label="Saldo Inicial"
          value={form.balance}
          placeholder="R$ 0,00"
          onChange={(value) => onChange('balance', value)}
        />
        <LabelSelect menuPortalTarget={document.body}
          label="Status"
          options={STATUS_OPTIONS}
          value={STATUS_OPTIONS.find((o) => o.value === form.status)}
          placeholder="Selecione"
          onChange={(opt) => onChange('status', opt?.value || 'ativo')}
        />
      </div>

      <LabelInput
        label="Observação"
        value={form.observation}
        placeholder="Ex: Conta principal da empresa..."
        max={255}
        onChange={(value) => onChange('observation', value)}
      />
    </FinancialFormModal>
  );
};

export default BankFormModal;
